import { MorphemeInfoView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.info";
import { WordReferenceCaligraphyScreen } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.word._screens.caligraphy";
import { WordReferenceDictionaryScreen } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.word._screens.dictionary";
import { WordReferenceLearningProgressScreen } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.word._screens.learning-progress";
import { type ReactElement } from "react";

const wordReferenceTabList = [
  { segment: "dictionary", title: "Dictionary" },
  { segment: "caligraphy", title: "Caligraphy" },
  { segment: "progress", title: "Progress" },
] as const;

const screenRenderers: Record<string, (word: string) => ReactElement> = {
  caligraphy: (word) => <WordReferenceCaligraphyScreen word={word} />,
  dictionary: (word) => <WordReferenceDictionaryScreen word={word} />,
  progress: (word) => <WordReferenceLearningProgressScreen word={word} />,
};

export function WordReferenceView({ rawWord }: { rawWord: string }) {
  return (
    <MorphemeInfoView
      morpheme={rawWord}
      screenRenderers={screenRenderers}
      stateKeyPrefix="card-word-info"
      tabList={wordReferenceTabList}
    />
  );
}
